module.exports = __webpack_public_path__ + "static/media/logo.08e58f92.png";